@if (train?.trainStatus === 'CANCELLED' && isAdmin) {
  <eg-pill [value]="0" [colors]="capacityValueColors" type="number" [comparisonValue]="getPillComparisonValue(0, 0)">
    <span class="value">0</span> / 0 {{ type === 'capacity' ? 'TEU' : 't' }}
  </eg-pill>
} @else if (type === 'capacity') {
  <eg-pill
    [value]="train?.remainingCapacity"
    [colors]="capacityValueColors"
    type="number"
    [comparisonValue]="getPillComparisonValue(train?.remainingCapacity, train?.capacity)"
  >
    @if (isAdmin) {
      <span class="value">{{ train.capacity - train.remainingCapacity }}</span> / {{ train.capacity }} TEU
    } @else if (!isAdmin && train.capacity !== null) {
      @if (train.remainingCapacity === null) {
        {{ train.capacity }} TEU
      } @else {
        <span class="value">{{ train.capacity - train.remainingCapacity }}</span> / {{ train.capacity }} TEU
      }
    }
  </eg-pill>
} @else if (type === 'weight') {
  <eg-pill
    [value]="train?.remainingWeight"
    [colors]="capacityValueColors"
    type="number"
    [comparisonValue]="getPillComparisonValue(train?.remainingWeight, train?.weight)"
  >
    @if (isAdmin) {
      <span class="value">{{ (train?.weight - train?.remainingWeight) / 1000 | egNumber: '1.0-0' }}</span> /
      {{ (train?.weight || 0) / 1000 | egNumber: '1.0-0' }} t
    } @else {
      @if (train.remainingWeight === null) {
        {{ (train.weight || 0) / 1000 | egNumber: '1.0-0' }} t
      } @else {
        <span class="value">{{ (train?.weight - train?.remainingWeight) / 1000 | egNumber: '1.0-0' }}</span> /
        {{ (train?.weight || 0) / 1000 | egNumber: '1.0-0' }} t
      }
    }
  </eg-pill>
}
